<div class="row equal-height-row spacing-30">
  <div class="col-lg-6 col-12">
    <div class="card h-100">
      <div class="card-header cursor-pointer align-items-center">
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Event Details</h3>
        </div>
        <div class="d-flex gap-2">
          <app-button
            [label]="'Edit Event'"
            [variant]="'primary'"
            [iconClass]="'fa fa-edit'"
            (clicked)="openEditEventModal()"
          />
        </div>
      </div>
      <div class="card-body p-9">
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">Event name</label>
          <div class="col-lg-8">
            <span class="fw-bold fs-6 text-gray-800">{{ event.event_name }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">Event Type</label>
          <div class="col-lg-8 fv-row">
            <span class="fw-semibold text-gray-800 fs-6">{{ event.event_type?.event_type_name }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">Registration deadline</label>
          <div class="col-lg-8 d-flex align-items-center">
            <span class="fw-semibold fs-6 text-gray-800 me-2">{{ formatTimeDMYHHMM(event.registration_deadline!) }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">Start date</label>
          <div class="col-lg-8 d-flex align-items-center">
            <span class="fw-semibold fs-6 text-gray-800 me-2">{{ formatTimeDMYHHMM(event.start_date!) }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">End date</label>
          <div class="col-lg-8 d-flex align-items-center">
            <span class="fw-semibold fs-6 text-gray-800 me-2">{{ formatTimeDMYHHMM(event.end_date!) }}</span>
          </div>
        </div>
        <div class="row mb-7">
          <label class="col-lg-4 fw-semibold text-muted">Address</label>
          <div class="col-lg-8">
            <a href="#" class="fw-semibold fs-6 text-gray-800 text-hover-primary">{{event.address}}, {{event.postal_code}} {{event.city}}, {{event.country}}</a>
          </div>
        </div>
        <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6">
          <i class="ki-duotone ki-information fs-2tx text-warning me-4">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          <div class="d-flex flex-stack flex-grow-1">
            <div class="fw-semibold">
              <h4 class="text-gray-900 fw-bold">We need your attention!</h4>
              <div class="fs-6 text-gray-700">Your event is still not published. To publish the event, please press the "Publish" button above.</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6 col-12">
    <div class="card h-100">
      <div class="card-header cursor-pointer">
        <div class="card-title m-0">
          <h3 class="fw-bold m-0">Event Description</h3>
        </div>
      </div>
      <div class="card-body p-9 scrollable-card">
        <div [innerHTML]="event.event_description"></div>
      </div>
    </div>
  </div>
</div>
<div class="row gy-5 g-xl-10">
  <div class="col-xl-8 mb-xl-10">
    <div class="card card-flush h-lg-100">
      <div class="card-header flex-nowrap pt-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-900">Event Class Registrations</span>
          <span class="text-gray-500 pt-2 fw-semibold fs-6">8k total registrations</span>
        </h3>
      </div>
      <div class="card-body pt-5 ps-6">
        <div id="kt_charts_widget_5" class="min-h-auto"></div>
      </div>
    </div>
  </div>
  <div class="col-xl-4 mb-5 mb-xl-10">
    <div class="card h-md-100" dir="ltr">
      <div class="card-body d-flex flex-column flex-center">
        <div class="mb-2">
          <h1 class="fw-semibold text-gray-800 text-center lh-lg">Have you tried
            <br />our new
            <span class="fw-bolder">Promotion QR code?</span></h1>
          <div class="py-10 text-center">
            <img src="assets/media/svg/illustrations/easy/1.svg" class="theme-light-show w-200px" alt="" />
            <img src="assets/media/svg/illustrations/easy/1-dark.svg" class="theme-dark-show w-200px" alt="" />
          </div>
        </div>
        <div class="text-center mb-1">
          <a class="btn btn-sm btn-primary me-2" data-bs-target="#kt_modal_create_app" data-bs-toggle="modal">Try now</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row gy-5 g-xl-10">
  <div class="col-xl-4">
    <div class="card card-flush h-xl-100">
      <div class="card-header pt-7">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label fw-bold text-gray-900">Event Services</span>
          <span class="text-gray-500 mt-1 fw-semibold fs-6">Total services booked: 25</span>
        </h3>
        <div class="card-toolbar">
          <a href="apps/ecommerce/sales/details.html" class="btn btn-sm btn-light">Order Details</a>
        </div>
      </div>
      <div class="card-body">
        <div class="hover-scroll-overlay-y pe-6 me-n6" style="height: 415px">
          <div class="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
            <div class="d-flex flex-stack mb-3">
              <div class="me-3">
                <img src="assets/media/stock/ecommerce/210.png" class="w-50px ms-n1 me-1" alt="" />
                <a href="apps/ecommerce/catalog/edit-product.html" class="text-gray-800 text-hover-primary fw-bold">Elephant 1802</a>
              </div>
              <div class="m-0">
                <button class="btn btn-icon btn-color-gray-500 btn-active-color-primary justify-content-end" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                  <i class="ki-duotone ki-dots-square fs-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                  </i>
                </button>
                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
                  <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">Quick Actions</div>
                  </div>
                  <div class="separator mb-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Ticket</a>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Customer</a>
                  </div>
                  <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
                    <a href="#" class="menu-link px-3">
                      <span class="menu-title">New Group</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <div class="menu-sub menu-sub-dropdown w-175px py-4">
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Admin Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Staff Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Member Group</a>
                      </div>
                    </div>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Contact</a>
                  </div>
                  <div class="separator mt-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <div class="menu-content px-3 py-3">
                      <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-stack">
              <span class="text-gray-500 fw-bold">To:
																<a href="apps/ecommerce/sales/details.html" class="text-gray-800 text-hover-primary fw-bold">Jason Bourne</a></span>
              <span class="badge badge-light-success">Delivered</span>
            </div>
          </div>
          <div class="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
            <div class="d-flex flex-stack mb-3">
              <div class="me-3">
                <img src="assets/media/stock/ecommerce/209.png" class="w-50px ms-n1 me-1" alt="" />
                <a href="apps/ecommerce/catalog/edit-product.html" class="text-gray-800 text-hover-primary fw-bold">RiseUP</a>
              </div>
              <div class="m-0">
                <button class="btn btn-icon btn-color-gray-500 btn-active-color-primary justify-content-end" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                  <i class="ki-duotone ki-dots-square fs-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                  </i>
                </button>
                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
                  <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">Quick Actions</div>
                  </div>
                  <div class="separator mb-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Ticket</a>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Customer</a>
                  </div>
                  <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
                    <a href="#" class="menu-link px-3">
                      <span class="menu-title">New Group</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <div class="menu-sub menu-sub-dropdown w-175px py-4">
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Admin Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Staff Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Member Group</a>
                      </div>
                    </div>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Contact</a>
                  </div>
                  <div class="separator mt-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <div class="menu-content px-3 py-3">
                      <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-stack">
              <span class="text-gray-500 fw-bold">To:
																<a href="apps/ecommerce/sales/details.html" class="text-gray-800 text-hover-primary fw-bold">Marie Durant</a></span>
              <span class="badge badge-light-primary">Shipping</span>
            </div>
          </div>
          <div class="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
            <div class="d-flex flex-stack mb-3">
              <div class="me-3">
                <img src="assets/media/stock/ecommerce/214.png" class="w-50px ms-n1 me-1" alt="" />
                <a href="apps/ecommerce/catalog/edit-product.html" class="text-gray-800 text-hover-primary fw-bold">Yellow Stone</a>
              </div>
              <div class="m-0">
                <button class="btn btn-icon btn-color-gray-500 btn-active-color-primary justify-content-end" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                  <i class="ki-duotone ki-dots-square fs-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                  </i>
                </button>
                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
                  <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">Quick Actions</div>
                  </div>
                  <div class="separator mb-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Ticket</a>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Customer</a>
                  </div>
                  <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
                    <a href="#" class="menu-link px-3">
                      <span class="menu-title">New Group</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <div class="menu-sub menu-sub-dropdown w-175px py-4">
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Admin Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Staff Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Member Group</a>
                      </div>
                    </div>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Contact</a>
                  </div>
                  <div class="separator mt-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <div class="menu-content px-3 py-3">
                      <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-stack">
              <span class="text-gray-500 fw-bold">To:
																<a href="apps/ecommerce/sales/details.html" class="text-gray-800 text-hover-primary fw-bold">Dan Wilson</a></span>
              <span class="badge badge-light-danger">Confirmed</span>
            </div>
          </div>
          <div class="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
            <div class="d-flex flex-stack mb-3">
              <div class="me-3">
                <img src="assets/media/stock/ecommerce/211.png" class="w-50px ms-n1 me-1" alt="" />
                <a href="apps/ecommerce/catalog/edit-product.html" class="text-gray-800 text-hover-primary fw-bold">Elephant 1802</a>
              </div>
              <div class="m-0">
                <button class="btn btn-icon btn-color-gray-500 btn-active-color-primary justify-content-end" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                  <i class="ki-duotone ki-dots-square fs-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                  </i>
                </button>
                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
                  <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">Quick Actions</div>
                  </div>
                  <div class="separator mb-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Ticket</a>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Customer</a>
                  </div>
                  <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
                    <a href="#" class="menu-link px-3">
                      <span class="menu-title">New Group</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <div class="menu-sub menu-sub-dropdown w-175px py-4">
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Admin Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Staff Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Member Group</a>
                      </div>
                    </div>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Contact</a>
                  </div>
                  <div class="separator mt-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <div class="menu-content px-3 py-3">
                      <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-stack">
              <span class="text-gray-500 fw-bold">To:
																<a href="apps/ecommerce/sales/details.html" class="text-gray-800 text-hover-primary fw-bold">Lebron Wayde</a></span>
              <span class="badge badge-light-success">Delivered</span>
            </div>
          </div>
          <div class="border border-dashed border-gray-300 rounded px-7 py-3 mb-6">
            <div class="d-flex flex-stack mb-3">
              <div class="me-3">
                <img src="assets/media/stock/ecommerce/215.png" class="w-50px ms-n1 me-1" alt="" />
                <a href="apps/ecommerce/catalog/edit-product.html" class="text-gray-800 text-hover-primary fw-bold">RiseUP</a>
              </div>
              <div class="m-0">
                <button class="btn btn-icon btn-color-gray-500 btn-active-color-primary justify-content-end" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                  <i class="ki-duotone ki-dots-square fs-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                  </i>
                </button>
                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
                  <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">Quick Actions</div>
                  </div>
                  <div class="separator mb-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Ticket</a>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Customer</a>
                  </div>
                  <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
                    <a href="#" class="menu-link px-3">
                      <span class="menu-title">New Group</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <div class="menu-sub menu-sub-dropdown w-175px py-4">
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Admin Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Staff Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Member Group</a>
                      </div>
                    </div>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Contact</a>
                  </div>
                  <div class="separator mt-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <div class="menu-content px-3 py-3">
                      <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-stack">
              <span class="text-gray-500 fw-bold">To:
																<a href="apps/ecommerce/sales/details.html" class="text-gray-800 text-hover-primary fw-bold">Ana Simmons</a></span>
              <span class="badge badge-light-primary">Shipping</span>
            </div>
          </div>
          <div class="border border-dashed border-gray-300 rounded px-7 py-3">
            <div class="d-flex flex-stack mb-3">
              <div class="me-3">
                <img src="assets/media/stock/ecommerce/192.png" class="w-50px ms-n1 me-1" alt="" />
                <a href="apps/ecommerce/catalog/edit-product.html" class="text-gray-800 text-hover-primary fw-bold">Yellow Stone</a>
              </div>
              <div class="m-0">
                <button class="btn btn-icon btn-color-gray-500 btn-active-color-primary justify-content-end" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" data-kt-menu-overflow="true">
                  <i class="ki-duotone ki-dots-square fs-1">
                    <span class="path1"></span>
                    <span class="path2"></span>
                    <span class="path3"></span>
                    <span class="path4"></span>
                  </i>
                </button>
                <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px" data-kt-menu="true">
                  <div class="menu-item px-3">
                    <div class="menu-content fs-6 text-gray-900 fw-bold px-3 py-4">Quick Actions</div>
                  </div>
                  <div class="separator mb-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Ticket</a>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Customer</a>
                  </div>
                  <div class="menu-item px-3" data-kt-menu-trigger="hover" data-kt-menu-placement="right-start">
                    <a href="#" class="menu-link px-3">
                      <span class="menu-title">New Group</span>
                      <span class="menu-arrow"></span>
                    </a>
                    <div class="menu-sub menu-sub-dropdown w-175px py-4">
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Admin Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Staff Group</a>
                      </div>
                      <div class="menu-item px-3">
                        <a href="#" class="menu-link px-3">Member Group</a>
                      </div>
                    </div>
                  </div>
                  <div class="menu-item px-3">
                    <a href="#" class="menu-link px-3">New Contact</a>
                  </div>
                  <div class="separator mt-3 opacity-75"></div>
                  <div class="menu-item px-3">
                    <div class="menu-content px-3 py-3">
                      <a class="btn btn-primary btn-sm px-4" href="#">Generate Reports</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-stack">
              <span class="text-gray-500 fw-bold">To:
																<a href="apps/ecommerce/sales/details.html" class="text-gray-800 text-hover-primary fw-bold">Kevin Leonard</a></span>
              <span class="badge badge-light-danger">Confirmed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
